import {Injectable} from '@angular/core';
import {CoreMenuService} from '@core/components/core-menu/core-menu.service';
import {Store} from '@ngrx/store';
import {UserSettings} from 'app/global/user-settings.dto';
import {hasAddonPermission, selectUserSetting} from 'app/store/reducers/user_settings.reducer';
import {filter, Observable, take} from 'rxjs';

export const permissionAddons = ['CC'];
@Injectable({
    providedIn: 'root'
})

export class AddonPermissionService {

    private userSettings$: Observable<UserSettings> = this._store$.select(selectUserSetting);
    constructor(
        private _coreMenu: CoreMenuService,
        private _store$: Store,
    ) {}





    /**
     * Hide sidebar menus if their addons are not activated
     */
    detectAddonPermission(){
        this.userSettings$.pipe(filter((user_settings) => user_settings && Object.keys(user_settings)?.length > 0), take(1)).subscribe(user_settings => {
            const useraddons = user_settings?.workspaces?.find(x => x?.default == true)?.addon_setting;
            const menu = this._coreMenu.getCurrentMenu();
            const updateMenuVisibility = (item) => {
                if (permissionAddons.includes(item.id)) {
                    item.hidden = useraddons?.length === 0 || !useraddons?.some((i: {key:string, active:boolean }) => i.key === item.id && i.active);
                }
                return item;
            };
            const settingsMenu = menu.find(m => m.id === 'settings');
            if (settingsMenu?.children) {
                settingsMenu.children = settingsMenu.children.map(updateMenuVisibility);
            }
            this._coreMenu.unregister('main');
            this._coreMenu.register('main', menu);
            this._coreMenu.setCurrentMenu('main');
        });
    }






    /**
     * Get addon permission
     * @param key
     * @returns Boolean
     */
    getAddonPermission(key: string): Observable<boolean>{
        return this._store$.select(hasAddonPermission(key));
    }
}
